import { SITE_SECONDARY_COLOR } from "@api/constants";
import { CFC } from "@api/types/cypress";
import React, { Fragment } from "react";

const Modal: CFC<{ children: React.ReactNode; show: boolean; close: () => void }> = ({
  children,
  show = false,
  close = () => {},
}) => (
  <Fragment>
    {show && (
      <div className="modal">
        <span className="close-icon" onClick={close} />
        <section className="modal-main">{children}</section>
        <style jsx>{`
          * {
            -webkit-overflow-scrolling: touch;
          }

          .modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            top: 50%;
            left: 50%;
            right: auto;
            bottom: auto;
            margin-right: -50%;
            transform: translate(-50%, -50%);
            overflow: auto;
            z-index: 9999;
          }

          .modal-main {
            position: fixed;
            background: white;
            width: 80%;
            height: 90%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            overflow-y: scroll;
            padding: 20px;
            border: 3px solid ${SITE_SECONDARY_COLOR};
          }

          .close-icon {
            display: block;
            box-sizing: border-box;
            width: 22px;
            height: 22px;
            border-width: 3px;
            border-style: solid;
            border-color: ${SITE_SECONDARY_COLOR};
            border-radius: 100%;
            background:
              -webkit-linear-gradient(
                -45deg,
                transparent 0%,
                transparent 46%,
                white 46%,
                white 56%,
                transparent 56%,
                transparent 100%
              ),
              - webkit-linear-gradient(
                  45deg,
                  transparent 0%,
                  transparent 46%,
                  white 46%,
                  white 56%,
                  transparent 56%,
                  transparent 100%
                );
            background-color: ${SITE_SECONDARY_COLOR};
            transition: all 0.3s ease;
            position: fixed;
            top: 4%;
            right: 9.5%;
            z-index: 9999;
          }
        `}</style>
      </div>
    )}
  </Fragment>
);

export default Modal;
